export default __webpack_public_path__ + "static/media/tuitions.de4e6937.svg";